import React from 'react';
import { Container } from "../../components/Container/Container";
import Feedback from '../../components/Feedback/Feedback'
import {
    ContainerCatalogStyled
} from "../auth/style";

const FeedbackPage = () => (
    <ContainerCatalogStyled style={{ paddingTop: "100px" }}>
        <Container>
            <Feedback />
        </Container>
    </ContainerCatalogStyled>
);

export default FeedbackPage;
